import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="navigations--navbar"
export default class extends Controller {
  static values = { expanded: Boolean };
  static targets = ["button", "mobileMenu"];

  connect() {
    if (!this.mobileMenuTarget.classList.contains("hidden")) {
      this.mobileMenuTarget.classList.add("hidden");
    }
    this.buttonTarget.ariaExpanded = this.expandedValue;
  }

  toggleMenuExpansion() {
    if (this.expandedValue) {
      this.mobileMenuTarget.classList.add("hidden");
      this.toggleExpansion();
    } else {
      this.mobileMenuTarget.classList.remove("hidden");
      this.toggleExpansion();
    }
  }

  toggleExpansion() {
    this.expandedValue = !this.expandedValue;
    this.buttonTarget.ariaExpanded = this.expandedValue;
  }
}
